import React from 'react';
import { DEBUG } from '../constants';
import { AdventCalendarEntry } from '../types';
import "./AdventCalendarDoor.css";

interface AdventCalendarDoorProps {
  item: AdventCalendarEntry;
  open: boolean
  onDoorClick: (entry: AdventCalendarEntry) => void;
  onContentClick: (entry: AdventCalendarEntry) => void;
}

export function isOpenable(entry: AdventCalendarEntry) {
  if (DEBUG)
    return true; // for dev
  else
    return new Date(2023, 11, entry.door) <= new Date(); // for prod
}

export default function AdventCalendarDoor(props: AdventCalendarDoorProps) {
  return (
    <article key={props.item.door} className="present">
      <div
        id={"pane" + props.item.door}
        className={"present__pane" + (props.open ? " present__open" : "")}
        onClick={(e) => props.onDoorClick(props.item)}
      >
        <h2 className="present__date">{props.item.door}</h2>
      </div>
      <div
        className={
          "present__content" + (props.open ? " present__content__open" : "")
        }
      >
        {isOpenable(props.item) ? (
          <div
            onClick={() => props.onContentClick(props.item)}
            className="present__emoji"
          >
            <img
              className="present__thumbnail"
              alt="Funny Santa"
              src={props.item.image}
            />
          </div>
        ) : null}
      </div>
    </article>
  );
}
